export default __webpack_public_path__ + "static/dust-cb16645db3377eeaae0bc0bb2d555ef0.png";